import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import FeatureTile from '../components/FeatureTile';
import FAQ from '../components/FAQ';
import heroData from '../data/hero.json';
import featuresData from '../data/features.json';
import seoData from '../data/seo.json';

const Home = () => {
    return (
        <div className="pt-36">
            <SEO page="home" />

            {/* Hero Section */}
            <Hero
                title={heroData.title}
                description={heroData.description}
                buttons={heroData.buttons}
            />

            {/* Emergency Banner */}
            <section className="container mx-auto px-4 pt-4">
                <div className="glass-panel p-6 mx-auto text-center bg-gradient-to-r from-red-500/10 to-red-400/10 border-red-400/30 animate-fade-in opacity-0 animation-delay-400">
                    <p className="text-xl md:text-2xl font-bold text-text-dark mb-3">🚨 Need Emergency Help?</p>
                    <a
                        href={`tel:${seoData.business.phone.replace(/[^0-9]/g, '')}`}
                        className="inline-block glass-button text-xl px-8 py-4"
                    >
                        Call Now: {seoData.business.phone}
                    </a>
                </div>
            </section>

            {/* Features Section */}
            <section className="container mx-auto px-4 py-20">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {featuresData.map((feature, index) => (
                        <FeatureTile
                            key={feature.id}
                            title={feature.title}
                            description={feature.description}
                            index={index}
                        />
                    ))}
                </div>
            </section>

            {/* Service Areas Section */}
            <section className="container mx-auto px-4 py-16">
                <div className="glass-panel p-12 text-center animate-fade-in opacity-0 animation-delay-100">
                    <h2 className="text-3xl font-bold mb-6 text-text-dark">Serving Calgary & Surrounding Areas</h2>
                    <p className="text-text-light mb-8 max-w-2xl mx-auto">
                        Your trusted local plumber near me Calgary choice. We provide fast, reliable plumbing and heating services throughout the Calgary metropolitan area.
                    </p>
                    <div className="flex flex-wrap justify-center gap-3">
                        {seoData.business.serviceAreas.map((area, index) => (
                            <span
                                key={index}
                                className="px-4 py-2 bg-white/50 rounded-full text-sm font-medium text-text-dark border border-glass-border"
                            >
                                {area}
                            </span>
                        ))}
                    </div>
                    <div className="mt-8">
                        <Link to="/contact">
                            <button className="glass-button px-8 py-4">
                                Get a Free Quote
                            </button>
                        </Link>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <FAQ />
        </div>
    );
};

export default Home;
